module.exports = __webpack_public_path__ + "static/assets/40e02f053e2601b37494f1ac89221be0.png";